import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort-amount-asc",
  "use": "sort-amount-asc-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sort-amount-asc\">\n  <path d=\"M3 8h6V6H3v2zm0 8v2h18v-2H3zm0-3h12v-2H3v2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol